// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerTableHandleColumnPopupElement, type TableHandleColumnPopupElement } from '@prosekit/web/table-handle';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes } from 'react';

/** Props for the {@link TableHandleColumnPopup} React component. */
export interface TableHandleColumnPopupProps {}

function TableHandleColumnPopupComponent(props: TableHandleColumnPopupProps, forwardedRef: ForwardedRef<TableHandleColumnPopupElement>) {
  registerTableHandleColumnPopupElement();

  const elementRef = useRef<TableHandleColumnPopupElement>(null);

  const { ...restProps } = props;

  const mergedRef = useCallback(
    (element: TableHandleColumnPopupElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-table-handle-column-popup', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-table-handle-column-popup` custom element. */
export const TableHandleColumnPopup: ForwardRefExoticComponent<TableHandleColumnPopupProps & HTMLAttributes<TableHandleColumnPopupElement> & RefAttributes<TableHandleColumnPopupElement>> = /* @__PURE__ */ forwardRef(TableHandleColumnPopupComponent);
